<template>
  <div>
    <el-tabs v-model="activeName">
      <!-- 待申诉、申诉中、申诉完成 -->
      <el-tab-pane label="未预付" name="1">
        <tablePre v-if="activeName === '1'" :prepaidStatus="0" />
      </el-tab-pane>
      <el-tab-pane label="预付中" name="2">
        <tablePre v-if="activeName === '2'" :prepaidStatus="1" />
      </el-tab-pane>
      <el-tab-pane label="已预付" name="3">
        <tablePre v-if="activeName === '3'" :prepaidStatus="2" />
      </el-tab-pane>
      <el-tab-pane label="全部" name="4">
        <tablePre v-if="activeName === '4'" :prepaidStatus="''" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tablePre from "./tablePre.vue";
export default {
  name: "AbnormalWaybill",
  components: {
    tablePre
  },
  data() {
    return {
      activeName: "1"
    };
  },
  watch: {
    $route(to, from) {
      this.activeName = "1";
    }
  }
};
</script>
<style scoped></style>
